var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGAlphabetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    height: 42,
    width: 42,
    fill: "#03B6FC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "G logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.47,0h81.58a19.79,19.79,0,0,1,14,5.82l.32.35a19.79,19.79,0,0,1,5.5,13.66v83.22a19.91,19.91,0,0,1-19.83,19.83H19.83A19.91,19.91,0,0,1,0,103.05V21.47A21.56,21.56,0,0,1,21.47,0ZM68.52,72.81V70.42H64V56.89H85.32V86.42a60.88,60.88,0,0,1-21.75,4q-15.14,0-20.78-7.34a22.37,22.37,0,0,1-4.07-8.93,58.89,58.89,0,0,1-1.16-12.69,56.12,56.12,0,0,1,1.2-12.64,21.74,21.74,0,0,1,4.29-8.89q5.84-7.42,22.55-7.43a74.07,74.07,0,0,1,9,.71,44.22,44.22,0,0,1,8.1,1.59L80,48.31a76.18,76.18,0,0,0-13-1.24c-3.86,0-6.58.29-8.14.88a3.45,3.45,0,0,0-2.34,3.54v25h5.84a12,12,0,0,0,4.64-.66c1-.45,1.46-1.47,1.46-3Zm34.53-62.7H21.47A11.37,11.37,0,0,0,10.11,21.47v81.58a9.77,9.77,0,0,0,9.72,9.72h83.22a9.73,9.73,0,0,0,9.72-9.72V19.83a9.73,9.73,0,0,0-2.62-6.64l-.24-.22a9.69,9.69,0,0,0-6.86-2.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGAlphabetIcon);
export default __webpack_public_path__ + "static/media/g-alphabet-icon.a3b2390b61d57d43b255bde79b5d8cb6.svg";
export { ForwardRef as ReactComponent };